import {AbstractPricingItemSummaryMapper} from "../../abstract-pricing-item-summary.mapper";
import {PricingItem} from "../../../../../../domain/in/quote/pricing-item/pricing-item";
import {PricingItemSummary} from "../../../../../../domain/out/pricing-item-summary";
import {DevicePricingItem} from "../../../../../../domain/in/quote/pricing-item/device-pricing-item";
import {MappingContext} from "../../mapping-context";

export class FrAcDasriSynthesisMapper extends AbstractPricingItemSummaryMapper {

    protected async doMap(pricingItem: PricingItem, ctx: MappingContext): Promise<PricingItemSummary> {
        let devicePricingItem = pricingItem as DevicePricingItem;
        let pricingItemSummary = new PricingItemSummary();
        pricingItemSummary.codeElis = await ctx.resolveCodeElis(devicePricingItem.device.codeElis);
        pricingItemSummary.label = this.getLabel(devicePricingItem);
        pricingItemSummary.quantity = this.getQuantity(devicePricingItem);
        pricingItemSummary.appliedPrice = this.getAppliedPrice(devicePricingItem, ctx);
        pricingItemSummary.totalAppliedPrice = ctx.formatAmount(pricingItem.totalAppliedPrice);
        pricingItemSummary.frequency = await ctx.getFrequency(devicePricingItem);
        pricingItemSummary.collecteurExtraPrice = this.getCollecteurExtraPrice(devicePricingItem, ctx);
        pricingItemSummary.serviceExtraPrice = this.getServiceExtraPrice(devicePricingItem, ctx);
        return pricingItemSummary;
    }


    getLabel(pricingItem: DevicePricingItem) {
        return pricingItem.device.label;
    }

    getAppliedPrice(pricingItem: DevicePricingItem, ctx: MappingContext) {
        return ctx.formatAmount(pricingItem.device.appliedPrice);
    }

    getQuantity(pricingItem: DevicePricingItem) {
        return pricingItem.userInputs.quantity;
    }

    getCollecteurExtraPrice(pricingItem: DevicePricingItem, ctx: MappingContext) {
        return ctx.formatAmount(pricingItem.collectorExtraPrice);
    }

    getServiceExtraPrice(pricingItem: DevicePricingItem, ctx: MappingContext) {
        return ctx.formatAmount(pricingItem.userInputs.serviceExtraPrice);
    }

}
